import { RELAY_FACET_PHOTO_FACET_TYPE_MAP } from '../constants';

import {
    type RelayFacets,
    type RelayFacetPayload,
    type FacetSearchPayloadValues,
    type RelayVariables,
    type FacetSearchPayload,
    type PhotoFacetType,
    type RelayFacetType,
} from '../types';

type MapRelayFacetValuesPayload = {
    variables: readonly string[];
    facet?: RelayFacetPayload;
};

function mapRelayFacetValues({
    variables,
    facet,
}: MapRelayFacetValuesPayload): FacetSearchPayloadValues {
    return (
        (facet || [])
            .filter(f => (variables || []).includes(f?.label || ''))
            .map(f => ({
                value: f?.label || '',
                label: f?.name || '',
            }))
            // sort facet values because new array may contain the same values in a
            // different order, causing extra renders and, under certain circumstances,
            // infinite loops
            .sort((a, b) => a.value.localeCompare(b.value))
    );
}

type MapRelayFacetsPayload = {
    variables: Omit<RelayVariables, 'hasUserId'>;
    facets?: RelayFacets;
};

type MapRelayFacetsResponse = Pick<FacetSearchPayload, PhotoFacetType>;

export function mapRelayFacets({
    variables,
    facets,
}: MapRelayFacetsPayload): MapRelayFacetsResponse {
    const mappedFacets = {} as MapRelayFacetsResponse;
    if (facets) {
        for (const [key, value] of Object.entries(facets)) {
            const facetType = RELAY_FACET_PHOTO_FACET_TYPE_MAP[key as RelayFacetType];
            mappedFacets[facetType] = mapRelayFacetValues({
                variables: variables[facetType] ?? [''],
                facet: value,
            });
        }
    }
    return mappedFacets;
}
